import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { getFileName } from '../../../feat/media/media.slice'
import { CacheFile, Utils } from '../../../utils'
import { useObjectContext } from '../providers/objectProvider'
interface FileListProps {
    files: string[]
}
export const FileList = ({ files }: FileListProps) => {
    const { past } = useObjectContext()
    useMemo(() => {
        if (files.length > 0) {
            files.forEach(async (f) => {
                await CacheFile(f)
            })
        }
    }, [files])
    return (
        <>
            {files.length > 0 && (
                <Stack spacing="12px">
                    {' '}
                    {/* I have removed the padding  24px from  here as its used in multiple locations.*/}
                    {files &&
                        typeof files !== 'undefined' &&
                        files.map((f, i) => {
                            return (
                                <Stack
                                    key={i}
                                    spacing="12px"
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    <Typography
                                        id={i + 'Uploadedfile'}
                                        onClick={(e) => {
                                            Utils.downloadAndOpenFile(f)
                                        }}
                                        style={{ lineBreak: 'anywhere' }}
                                        color={
                                            past
                                                ? ColoursObj.shades.shade2
                                                : undefined
                                        }
                                        variant={'bodyRegularUnderlined'}
                                    >
                                        {getFileName(f)}
                                    </Typography>
                                </Stack>
                            )
                        })}
                </Stack>
            )}
        </>
    )
}
